import { AsiakkaanTuote, LaskunAsiakas, LaskuToimittaja, TypeaheadAsiakas, TypeaheadToimittaja, TypeaheadTuote } from '@lemon/core-firebase/model/lasku'

export interface AsiakasTypeaheadResult {
  suodatetut: TypeaheadAsiakas[]
}

export abstract class LaskunAsiakasTypeaheadBase {
  public abstract haeJaSuodata(value: string): Promise<AsiakasTypeaheadResult>
  public abstract annaAsiakas(typeaheadAsiakas: TypeaheadAsiakas): Promise<LaskunAsiakas>
}

export interface TuoteTypeaheadResult {
  loytynyt: TypeaheadTuote
  suodatetut: TypeaheadTuote[]
}

export abstract class LaskunTuoteTypeaheadBase {
  public abstract haeJaSuodata(value: string): Promise<TuoteTypeaheadResult>
  public abstract getTuote(avain: string): Promise<AsiakkaanTuote>
}

export interface ToimittajaTypeaheadResult {
  suodatetut: TypeaheadToimittaja[]
}

export abstract class LaskunToimittajaTypeaheadBase {
  public abstract haeJaSuodata(value: string, palautaPoistetut?: boolean): Promise<ToimittajaTypeaheadResult>
  public abstract annaToimittaja(avain: string): Promise<LaskuToimittaja>
}
